import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeatureColorNameClasses = 'featureTitle' | 'selectedFeatureTitle';

const featureColorNameStyles = makeStyles<ISpcTheme, FeatureColorNameClasses>(
  ({ palette, typography }) => ({
    featureTitle: {
      color: palette.text.secondary,
      marginBottom: '8px',
      display: 'block',
    },
    selectedFeatureTitle: {
      display: 'flex',
      lineHeight: '1.5',
      fontSize: typography.fontSM,
    },
  }),
  { name: 'Customise_Feature_ColorName' },
);

export default featureColorNameStyles;
